function ellipsize(str, len = 10) {
  return str.length > len ? `${str.slice(0, len)}...` : str;
}

export default ellipsize;
